import dataTypeLabel from './dataTypeLabel'
import getDataCategories from './getDataCategories'
import messagesMultiSelect from './messagesMultiSelect'
import mountDataCollectedOptionsIDs from './mountDataCollectedOptionsIDs'
import mountLabelList from './mountLabelList'
import mountListOfAnotherOptions from './mountListOfAnotherOptions'
import mountNecessityAndProportionalityParams from './mountNecessityAndProportionalityParams'
import mountSelectedList from './mountSelectedList'
import mountUnnecessaryFields from './mountUnnecessaryFields'
import nameOfTitularAgeRange from './nameOfTitularAgeRange'
import rangeAgeContent from './rangeAgeContent'
import treatDataToSubmit from './treatDataToSubmit'

export default {
  dataTypeLabel,
  getDataCategories,
  messagesMultiSelect,
  mountDataCollectedOptionsIDs,
  mountLabelList,
  mountListOfAnotherOptions,
  mountNecessityAndProportionalityParams,
  mountSelectedList,
  mountUnnecessaryFields,
  nameOfTitularAgeRange,
  rangeAgeContent,
  treatDataToSubmit,
}
